import { ComponentsOverrides, Theme } from "@mui/material";

type MuiCardContent = {
  styleOverrides: ComponentsOverrides<Theme>["MuiCardContent"];
};

const muiCardContent: MuiCardContent = {
  styleOverrides: {
    root: {
      padding: "16px 24px 24px 24px",
    },
  },
};

export default muiCardContent;
